export const accessTokenCookieName = 'access_token';
export const refreshTokenCookieName = 'refresh_token';
export const backendBaseUrl = import.meta.env.VITE_BACKEND_BASE_URL;
export const NODE_ENV = import.meta.env.NODE_ENV;
export const apiProductBackendBaseUrl = import.meta.env
  .VITE_API_PRODUCT_BACKEND_BASE_URL;
export const S3Url = import.meta.env.VITE_S3_URL;
export const MAX_BATCH_SIZE = 1000;
export const MAX_FILE_SIZE = parseInt(import.meta.env.VITE_MAX_FILE_SIZE, 10);
export const awsAmplifyAutoLoginUsername = import.meta.env
  .VITE_AWS_AMPLIFY_AUTO_LOGIN_USERNAME;
export const awsAmplifyAutoLoginPassword = import.meta.env
  .VITE_AWS_AMPLIFY_AUTO_LOGIN_PASSWORD;
